
 <div *ngIf="institutiontypes" class="col-lg-12 p-3">
  <div class="d-flex justify-content-start gap-2">
            <button type="submit" (click)="saveForm()" class="btn border" [disabled]="!form.valid || form.disabled || !form.dirty">Spara</button>
            <button type="submit" (click)="cancel()" class="btn border" [disabled]="form.disabled">Avbryt</button>
  </div>
   
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-xs-12 col-md-6 col-xl-4">
          <mat-expansion-panel class="accordionmargin" [expanded]=true>
            <mat-expansion-panel-header [expandedHeight]="'48px'">
              <mat-panel-title>
                Institution - {{form.get('name').value}} ({{form.get('shortName').value}})
              </mat-panel-title>
           
            </mat-expansion-panel-header>
            <div class="form-row">
              <div *ngIf="userpermissionlevel === 'SY'" class="form-group col-md-9">
                <label for="institutionTypeId">
                  Institutionstyp
                </label>
                <select class="form-control form-control-sm" id="insitutiontype" formControlName="institutionTypeId" required>
                  <option></option>
                  <option *ngFor="let i of institutiontypes" [value]="i.id">{{i.prefix}} - {{i.name}}</option>
                </select>
                <span *ngIf="(institutionTypeId.dirty || institutionTypeId.touched) && institutionTypeId.invalid && institutionTypeId.errors.required">
                  Institutionstyp är obligatoriskt.
                </span>
              </div>
              <div *ngIf="userpermissionlevel !== 'SY'" class="form-group col-md-9">
                <label for="institutionTypeId">
                  Institutionstyp
                </label>
                <input type="text" class="form-control form-control-sm" id="institutiontypename" value="{{institutiontypename}}" readonly>
              </div>
            </div>
            <div class="form-group">
              <label for="name">
                Institutionsnamn
              </label>
              <input type="text" class="form-control form-control-sm" id="name" formControlName="name" required [readonly]="userpermissionlevel!=='SY'">
              <span *ngIf="(name.dirty || name.touched) && name.invalid && name.errors.required">
                Institutionsnamn är obligatoriskt.
              </span>
            </div>
  
            <div class="form-group">
              <label for="institutionNumber">
                Institutionsnummer
              </label>
              <input #instnumber type="text" class="form-control form-control-sm" id="institutionNumber" formControlName="institutionNumber" required (blur)="checkNumber()">
              <span *ngIf="(institutionNumber.dirty || institutionNumber.touched) && institutionNumber.invalid && institutionNumber.errors.required">
                Institutionsnummer är obligatoriskt.
              </span>
            </div>
            <div class="form-group">
              <label>
                Tillhör
              </label>
           
              
                <select class="form-control form-control-sm" id="parentInstitutionId" formControlName="parentInstitutionId" required>
                  <option></option>
                  <option *ngFor="let i of institutions" [ngValue]="i.id">{{i.shortName}} - {{i.name}}</option>
                </select>
             
            </div>
            <div class="form-group" style="width:150px;">
              <label for="organizationNumber">
                Organisationsnummer
              </label>
              <input type="text" class="form-control form-control-sm" id="organizationNumber" formControlName="organizationNumber" [readonly]="userpermissionlevel!=='SY'">
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="startDate">
                  Instituerad
                </label>
                <input type="text" class="form-control form-control-sm" id="startDate" formControlName="startDate" mask="0000-00-00" [readonly]="userpermissionlevel!=='SY'" required>
              </div>
            </div>
            <div class="form-group" style="width:200px;">
              <label for="installationInterval">
                Installation
              </label>
              <input type="text" class="form-control form-control-sm" id="installationInterval" formControlName="installationInterval" [readonly]="userpermissionlevel!=='SY'">
            </div>
            <div class="form-group">
              <label for="seat">
                Säte
              </label>
              <input type="text" class="form-control form-control-sm" id="seat" formControlName="seat" [readonly]="userpermissionlevel!=='SY'">
            </div>
            <div class="form-group">
              <label for="meetingInterval">
                Mötesdagar
              </label>
              <input type="text" class="form-control form-control-sm" id="meetingInterval" formControlName="meetingInterval" [readonly]="userpermissionlevel!=='SY'">
            </div>
          </mat-expansion-panel>
        </div>
        <div class="col-xs-12 col-md-6 col-xl-4">
          <div formGroupName="visitingAddress">
            <mat-expansion-panel class="accordionmargin" [expanded]=true>
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  Besöksadress
                </mat-panel-title>        
              </mat-expansion-panel-header>
              <div class="form-group">
                <label for="visitstreet">
                  Gata
                </label>
                <input type="text" class="form-control form-control-sm" id="visitstreet" formControlName="street">
              </div>
              <div class="form-group">
                <label for="visitcity">
                  Ort
                </label>
                <input type="text" class="form-control form-control-sm" id="visitcity" formControlName="city">
              </div>
              <div class="form-group">
                <label for="visitcountry">Land</label>
                <select class="form-control form-control-sm" id="visitcountry" formControlName="country">
                  <option></option>
                  <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                </select>
              </div>
            </mat-expansion-panel>
          </div>
          
          <div formGroupName="paymentAddress">
            <mat-expansion-panel class="accordionmargin" [expanded]=true>
              <mat-expansion-panel-header [expandedHeight]="'48px'">
                <mat-panel-title>
                  Postadress
                </mat-panel-title>
        
              </mat-expansion-panel-header>
              <div class="form-group">
                <label for="careOf">
                  C/O
                </label>
                <input type="text" class="form-control form-control-sm" id="careOf" formControlName="careOf">
              </div>
              <div class="form-group">
                <label for="street">
                  Gata/Box
                </label>
                <input type="text" class="form-control form-control-sm" id="street" formControlName="street">
              </div>
              <div class="form-group">
                <label for="zipCode">
                  Postnummer
                </label>
                <input type="text" class="form-control form-control-sm" id="zipCode" formControlName="zipCode">
              </div>
              <div class="form-group">
                <label for="city">
                  Postort
                </label>
                <input type="text" class="form-control form-control-sm" id="city" formControlName="city">
              </div>
              <div class="form-group">
                <label for="paymentcountry">Land</label>
                <select class="form-control form-control-sm" id="paymentcountry" formControlName="country">
                  <option></option>
                  <option *ngFor="let c of countries" [value]="c.name">{{c.name}}</option>
                </select>
              </div>
            </mat-expansion-panel>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 col-xl-4">
          <mat-expansion-panel class="accordionmargin" [expanded]=true>
            <mat-expansion-panel-header [expandedHeight]="'48px'">
              <mat-panel-title>
                Övrig kontaktinformation
              </mat-panel-title>
            
            </mat-expansion-panel-header>
            <div class="form-group">
              <label for="email">
                E-post
              </label>
              <input type="text" class="form-control form-control-sm" id="email" formControlName="email" [readonly]="roleid===1 || roleid===6">
            </div>
            <div class="form-row">
              <div class="form-group col-sm-6">
                <label for="phone">
                  Telefon
                </label>
                <input type="text" class="form-control form-control-sm" id="phone" formControlName="phone">
              </div>
              <div class="form-group col-sm-6">
                <label for="phoneMobile">
                  Mobil
                </label>
                <input type="text" class="form-control form-control-sm" id="phoneMobile" formControlName="phoneMobile">
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="swish">
                    Swish
                  </label>
                  <input type="text" class="form-control form-control-sm" id="swish" formControlName="swish">
                </div>

                <div class="form-group">
                  <label for="bankAccount1">
                    Postgiro
                  </label>
                  <input type="text" class="form-control form-control-sm" id="bankAccount1" formControlName="bankAccount1">
                </div>
                <div class="form-group">
                  <label for="bankAccount2">
                    Bankgiro
                  </label>
                  <input type="text" class="form-control form-control-sm" id="bankAccount2" formControlName="bankAccount2">
                </div>
                <div class="form-group">
                  <label for="webSite">
                    Hemsida
                  </label>
                  Institutionsinformation på <a href="//oddfellow.se/hitta/institution/?inst={{form.value.shortName}}" target="_blank" title="Öppna webbsida i nytt fönster"> www.OddFellow.se</a>
                  <div>
                    Institutionens egen hemsida:
                    <a *ngIf="form.value.webSite&&form.disabled" href="http://{{form.value.webSite}}" target="_blank"> {{form.value.webSite}}</a>
                  </div>
                  <input *ngIf="form.enabled" type="text" class="form-control form-control-sm" id="webSite" formControlName="webSite">
                </div>
              </div>
              <!--div class="col-md-6 py-3" style="text-align:center;display:grid;align-items:center;">
                <img *ngIf="!previewUrl && imageToShow !== null" mat-card-image src='{{imageToShow}}' style="max-width:150px;width:100%;margin:auto;border-radius:10px;border:1px solid #F0F0F0;">
                <div class="py-2">
                  <span *ngIf="form.enabled" class="d-flex justify-content-between">
                    <input type="file" id="file" (change)="fileChangeEvent($event)" />
                    <label for="file" style="margin-top:5px;" class="btn border">Välj sigill</label>
                
                    <button class="btn border" (click)="deleteEmblemImage()" style="margin-left:3px;"><i class="fa fa-trash"></i></button>
                  </span>
                  <div *ngIf="form.enabled" class="py-2 text-danger m-2 border border-danger rounded">Endast .jpg är tillåtet.</div>
                </div>
              </div-->
            </div>

          </mat-expansion-panel>
       
        </div>
      </div>
      <br>
    </form>
  </div>